import lang from "../../lib/appfuse-react/core/lang";
import newborns from "../caseInfo/newborns";

const positiveReportFormService = [{
    matcher: 'positiveReport',
    reply: config => {
        if(config.method==='post') {
            return [200, newborns[0]];
        } else {
            const {predicate} = config.params;
            let data;
            const selector = predicate?.node()?.selector?.();
            if (lang.isNotEmpty(selector)) {
                const value = predicate.node().expectation();
                if(lang.isEmpty(value)) {
                    return [200, newborns];
                }
                if(selector==='hospital') {
                    data = newborns.filter(newborn => newborn[selector]===value);
                }
            } else {
                data = newborns;
            }
            return [200, data];
        }
    }
}, {
    matcher: /positiveReport\/(.*)/,
    reply: config => {
        const id = /positiveReport\/(.*)/.exec(config.url)[1];
        const newborn = newborns.find(newborn => newborn.no === id);
        return [200, newborn];
    }
}];

export default positiveReportFormService;